import { IReportColumn } from '../../interfaces/report'
import { FilterFieldType, IFilter } from './types'

// A query's only List columns are booleans.
const BOOLEAN_OPTIONS = [
  { value: 'true', label: 'Yes' },
  { value: 'false', label: 'No' },
]

// Every result column is a filter field and a sort key. Text filters match on the value as
// text, so a uuid or array column filters like any other.
export const reportFilterConfig = (columns: IReportColumn[]): IFilter[] =>
  columns.map(({ key, title, type }) => {
    const filter = { field: key, alias: 'source', type, title, isSortable: true }
    if (type === FilterFieldType.Text) {
      return { ...filter, dbField: `"${key}"::text`, excludeFullSearchFilter: true }
    }
    if (type === FilterFieldType.List) {
      return { ...filter, isMultiple: true, options: BOOLEAN_OPTIONS }
    }
    return filter
  })

// The filter editor's fields: the config without its SQL. Text fields can include or
// exclude a value.
export const reportFilterFields = (columns: IReportColumn[]): IFilter[] =>
  reportFilterConfig(columns).map(
    ({ field, type, title, isMultiple, options, excludeFullSearchFilter }) => ({
      field,
      type,
      title,
      isMultiple,
      options,
      excludeFullSearchFilter,
      hasTextMatch: type === FilterFieldType.Text,
    }),
  )

// The columns `keys` names on `columns`, in the order given; unknown keys drop out.
export const pickReportColumns = (columns: IReportColumn[], keys: string[]): IReportColumn[] =>
  keys.flatMap((key) => {
    const column = columns.find((candidate) => candidate.key === key)
    return column ? [column] : []
  })
